<div class="top-indicator">
  <h1 style="font-size: 24px; font-family: Noto Sans JP; font-weight: bold;">{{'addNewVessel' | translate}}</h1>
</div>
<mat-progress-bar
  mode="determinate"
  [value]="progressValue"
></mat-progress-bar>
<mat-stepper linear="isLinear" #stepper class="stepper" (selectionChange)="onStepChange($event)" style="background-color: transparent;">
  <mat-step [stepControl]="vesselStepper.sectionOneFormGroup">
    <form [formGroup]="vesselStepper.sectionOneFormGroup" autocomplete="off" class="overflow-y-auto max-h-[calc(100vh-16rem)]">
      <ng-template matStepLabel>Section 1</ng-template>
      <div class="main-area">
        <div class="sub-title">{{'vesselInformation' | translate}}</div>   
        <div class="field-class">
          <span class="field-label">* {{ 'vesselName' | translate }}</span>
          <input type="text" class="input-field" matInput required id="name" placeholder="Enter Vessel Name" formControlName="name">
          <div *ngIf="sectionOneForm.get('name')?.invalid && sectionOneForm.get('name')?.touched" class="error-message">
            <div *ngIf="sectionOneForm.get('name')?.hasError('required')">This Field is Required</div>
          </div>
        </div>
        <div class="field-class">
          <span class="field-label">{{'otherName' | translate}}</span>
          <input type="text" matInput id="otherName" placeholder="Enter Other Name" formControlName="otherName" class="input-field"/>
        </div>
        <div class="field-class">
          <span class="field-label">{{'imo' | translate}}</span>
          <input type="text" matInput id="imo" placeholder="Enter IMO Number" formControlName="imo" class="input-field"/>
        </div>
        <div class="field-class">
          <span class="field-label">{{'vesselNumber' | translate}}</span>
          <input type="text" matInput id="vesselNumber" placeholder="Enter Vessel Number" formControlName="vesselNumber" class="input-field"/>
        </div>
        <div class="field-class">
          <span class="field-label">{{'vesselType' | translate}}</span>
          <mat-select class="input-field" formControlName="vesselType" #singleSelect [compareWith]="compareVesselTypes" [placeholder]="'selectVesselType' | translate">
            <mat-option  *ngFor="let types of vesselTypes" [value]="types.type">{{types.type}}</mat-option>
          </mat-select>
        </div>
        <div class="field-class">
          <span class="field-label">{{'shipType' | translate}}</span>
          <input type="text" matInput id="shipType"  placeholder="Enter Ship Type" formControlName="shipType" class="input-field"/>
        </div>
        <div class="field-class">
          <span class="field-label">{{'builtYear' | translate}}</span>
          <input type="text" matInput id="builtYear" placeholder="Enter Built Year" formControlName="builtYear" class="input-field"/>
        </div>
        <div class="field-class">
          <span class="field-label">{{'callSign' | translate}}</span>
          <input type="text" matInput id="callsign" placeholder="Enter Call Sign" formControlName="callsign" class="input-field"/>
        </div>
        <div class="field-class">
          <span class="field-label">{{'hotelPower' | translate}}</span>
          <input type="text" matInput id="hotelPower" placeholder="Enter Hotel Power" formControlName="hotelPower" class="input-field"/>
        </div>
        <div class="field-class">
          <span class="field-label">{{'numOfThrusters' | translate}}</span>
          <input type="text" matInput id="NoThruster" placeholder="Enter No. of Thruster" formControlName="NoThruster" class="input-field"/>
        </div>
        <div class="field-class">
          <span class="field-label">{{'numOfCrane' | translate}}</span>
          <input type="text" matInput id="NoCrane"  placeholder="Enter No. of Crane" formControlName="NoCrane" class="input-field"/>
        </div>
        <div class="field-class">
          <span class="field-label">{{'numOfLeg' | translate}}</span>
          <input type="text" matInput id="NoLeg" placeholder="Enter No. of Leg" formControlName="NoLeg" class="input-field"/>
        </div>
        <div class="field-class">
          <span class="field-label">{{'numOfMainEngines' | translate}}</span>
          <input type="text" matInput id="NoME" placeholder="Enter No. of Main Engines" formControlName="NoME" class="input-field"/>
        </div>
        <div class="field-class">
          <span class="field-label">{{'firstClassificationSociety' | translate}}</span>
          <input matInput type="tel" class="input-field" id="firstClass" [matAutocomplete]="auto4" formControlName="firstClass" placeholder="Enter a First Class"> 
              <mat-autocomplete #auto4="matAutocomplete">
                <mat-option *ngFor="let type of classificationSocietyType" [value]="type.type">
                  {{ type.type }}
                </mat-option>
              </mat-autocomplete>
        </div>
        <div class="field-class">
          <span class="field-label">{{'secondClassificationSociety' | translate}}</span>
          <input type="text" matInput id="secondClass" [matAutocomplete]="auto5" formControlName="secondClass" placeholder="Enter a Second Class" class="input-field"/>
          <mat-autocomplete #auto5="matAutocomplete">
            <mat-option *ngFor="let type of classificationSocietyType" [value]="type.type">
              {{ type.type }}
            </mat-option>
          </mat-autocomplete> 
        </div>

        <div class="sub-title">{{'idInfo' | translate}}</div>
        <div class="field-class">
          <span class="field-label">* {{'ownerId'|translate}}</span>
          <mat-select class="input-field" formControlName="owner_id" #singleSelect (selectionChange)="ownerSelection($event)" placeholder="Select a Company" required>
            <input type="text" (keyup)="filterCompany($event, 'owner')" id="owner_search" class="searches" placeholder="Search by name">
            <mat-option *ngFor="let company of ownerList" [value]="company.id">{{company.name}}</mat-option>
          </mat-select>
        </div>
        <div class="field-class">
          <span class="field-label">* {{'managerId'|translate}}</span>
          <mat-select class="input-field" formControlName="manager_id" #singleSelect (selectionChange)="managerSelection($event)" placeholder="Select a Company" required>
            <input type="text" (keyup)="filterCompany($event, 'manager')" id="manager_search" class="searches" placeholder="Search by name">
            <mat-option *ngFor="let company of managerList" [value]="company.id">{{company.name}}</mat-option>
          </mat-select>
        </div>
        <div class="field-class">
          <span class="field-label">{{'exOwnerId'|translate}}</span>
          <mat-select class="input-field" formControlName="exowner_id" #singleSelect (selectionChange)="exownerSelection($event)" placeholder="Select a Company">
            <input type="text" (keyup)="filterCompany($event, 'exowner')" id="exowner_search" class="searches" placeholder="Search by name">
            <mat-option *ngFor="let company of exownerList" [value]="company.id">{{company.name}}</mat-option>
          </mat-select>
        </div>
        <div class="field-class">
          <span class="field-label">{{'exManagerId'|translate}}</span>
          <mat-select class="input-field" formControlName="exmanager_id" #singleSelect (selectionChange)="exmanagerSelection($event)" placeholder="Select a Company">
            <input type="text" (keyup)="filterCompany($event, 'exmanager')" id="exmanager_search" class="searches" placeholder="Search by name">
            <mat-option *ngFor="let company of exmanagerList" [value]="company.id">{{company.name}}</mat-option>
          </mat-select>
        </div>
        <div class="field-class">
          <span class="field-label">{{'builderId'|translate}}</span>
          <mat-select class="input-field" formControlName="builder_id" #singleSelect (selectionChange)="builderSelection($event)" placeholder="Select a Company">
            <input type="text" (keyup)="filterCompany($event, 'builder')" id="builder_search" class="searches" placeholder="Search by name">
            <mat-option *ngFor="let company of builderList" [value]="company.id">{{company.name}}</mat-option>
          </mat-select>
        </div>
        <div class="field-class">
          <span class="field-label">{{'maintainerId'|translate}}</span>
          <mat-select class="input-field" formControlName="maintener_id" #singleSelect (selectionChange)="maintainerSelection($event)" placeholder="Select a Company">
            <input type="text" (keyup)="filterCompany($event, 'maintainer')" id="maintainer_search" class="searches" placeholder="Search by name">
            <mat-option *ngFor="let company of maintainerList" [value]="company.id">{{company.name}}</mat-option>
          </mat-select>
        </div>

        <div class="sub-title">{{'vesselIdentification' | translate}}</div>   
        <div class="field-class">
          <span class="field-label">{{'exName' | translate}}</span>
          <input type="text" matInput id="exName" formControlName="exName" placeholder="Enter Ex.Name" class="input-field"/>
        </div>
        <div class="field-class">
          <span class="field-label">{{'mmsi' | translate}}</span>
          <input type="text" matInput id="mmsi" formControlName="mmsi" placeholder="Enter MMSI" class="input-field"/>
        </div>
        <div class="field-class">
          <span class="field-label">{{'officialNumber' | translate}}</span>
          <input type="text" matInput id="officialNumber" formControlName="officialNumber" placeholder="Enter Official Number" class="input-field"/>
        </div>
        <div class="field-class">
          <span class="field-label">{{'signalLetter' | translate}}</span>
          <input type="text" matInput id="signalLetters" formControlName="signalLetters" placeholder="Enter Signal Letters" class="input-field"/>
        </div>
        <div class="field-class">
          <span class="field-label">{{'flag' | translate}}</span>
          <input type="text" matInput id="flag" formControlName="flag" placeholder="Enter Flag" class="input-field"/>
        </div>
        <div class="field-class">
          <span class="field-label">{{'portOfRegistry' | translate}}</span>
          <input type="text" matInput id="portOfRegistry" formControlName="portOfRegistry" placeholder="Enter Port of Registry" class="input-field"/>
        </div>
      </div>
      <div class="btn-area">
        <button type="button" class="cancel-btn" (click)="onClose()">{{'cancel' | translate}}</button>
        <button type="button" class="next-btn" matStepperNext>{{'next' | translate}}</button>
      </div>
      
    </form>
  </mat-step>
  <mat-step [stepControl]="vesselStepper.sectionTwoFormGroup">
    <form [formGroup]="vesselStepper.sectionTwoFormGroup" autocomplete="off" class="overflow-y-auto max-h-[calc(100vh-16rem)]">
      <ng-template matStepLabel>Section 2</ng-template>
      <div class="main-area">
        <div class="sub-title">{{'dimension' | translate}}</div>   
        <div class="field-class-two-column">
          <div class="field-class-sub-left">
            <span class="field-label">{{'totalLength' | translate}}</span>
            <input type="text" matInput class="input-field" id="totalLength" placeholder="Enter Total Length" formControlName="totalLength"> 
          </div>
          <div class="field-class-sub-right">       
            <span class="field-label">{{'waterLineLength' | translate}}</span>
            <input type="text" matInput class="input-field" id="waterlineLength" placeholder="Enter Water Line Length" formControlName="waterlineLength">
          </div> 
        </div>
        <div class="field-class">
          <span class="field-label">{{'lbp' | translate}}</span>
          <input type="text" matInput id="LBP" placeholder="Enter LBP" formControlName="LBP" class="input-field"/>
        </div>
        <div class="field-class">
          <span class="field-label">{{'width' | translate}}</span>
          <input type="text" matInput id="width" placeholder="Enter Width" formControlName="width" class="input-field"/>
        </div>
        <div class="field-class">
          <span class="field-label">{{'draft' | translate}}</span>
          <input type="text" matInput id="draft" placeholder="Enter Draft" formControlName="draft" class="input-field"/>
        </div>
        <div class="field-class">
          <span class="field-label">{{'mouldedDepth' | translate}}</span>
          <input type="text" matInput id="mouldedDepth" placeholder="Enter Moulded Depth" formControlName="mouldedDepth" class="input-field"/>
        </div>

        <div class="sub-title">{{'tonnage' | translate}}</div>   
        <div class="field-class">
          <span class="field-label">{{'netTonnage' | translate}}</span>
          <input type="text" matInput id="netTonnage" placeholder="Enter Net Tonnage" formControlName="netTonnage" class="input-field"/>
        </div>
        <div class="field-class">
          <span class="field-label">{{'grossTonnage' | translate}}</span>
          <input type="text" matInput id="grossTonnage" placeholder="Enter Gross Tonnage" formControlName="grossTonnage" class="input-field"/>
        </div>
        <div class="field-class">
          <span class="field-label">{{'deadWeightTonnage' | translate}}</span>
          <input type="text" matInput id="deadweightTonnage" placeholder="Enter Dead Weight Tonnage" formControlName="deadweightTonnage" class="input-field"/>
        </div>

        <div class="sub-title">{{'additionalDetails' | translate}}</div>   
        <div class="field-class-two-column">
          <div class="field-class-sub-left">
            <span class="field-label">{{'bulbousBow' | translate}}</span>
            <input matInput type="number" formControlName="bulbousBow" class="input-field" placeholder="Enter Bulbous Bow"/>
          </div>
          <div class="field-class-sub-right">
            <span class="field-label">{{'meBuiltYear' | translate}}</span>
            <input matInput type="number" formControlName="meBuiltYear" class="input-field" placeholder="Enter ME BuiltYear"/>
          </div>
        </div>
        <div class="field-class-two-column">
          <div class="field-class-sub-left">
            <span class="field-label">{{'lw' | translate}}</span>
            <input matInput type="number" formControlName="L_w" class="input-field" placeholder="Enter L_w"/>
          </div>
          <div class="field-class-sub-right">
            <span class="field-label">{{'cb' | translate}}</span>
            <input matInput type="number" formControlName="C_B" class="input-field" placeholder="Enter C_B"/>
          </div>
        </div>
        <div class="field-class-two-column">
          <div class="field-class-sub-left">
            <span class="field-label">{{'etaD' | translate}}</span>
            <input matInput type="number" formControlName="eta_D" class="input-field" placeholder="Enter ETA_D"/>
          </div>
          <div class="field-class-sub-right">
            <span class="field-label">{{'maxSpeedKn' | translate}}</span>
            <input matInput type="number" formControlName="maxSpeedKn" class="input-field" placeholder="Enter Max Speed Kn"/>
          </div>
        </div>

        <div class="sub-title">{{'constructionDetails' | translate}}</div>   
        <div class="field-class-two-column">
          <div class="field-class-sub-left">
            <span class="field-label">{{'builtPlace' | translate}}</span>
            <input type="text" matInput formControlName="builtPlace" id="builtPlace" class="input-field" placeholder="Enter Built Place"/>
          </div>
          <div class="field-class-sub-right">
            <span class="field-label">{{'structuralDesignType' | translate}}</span>
            <input matInput [matAutocomplete]="auto" formControlName="structuralDesignType" placeholder="Enter Structural Design Type" class="input-field" placeholder="Enter Structural Design Type"/>
            <mat-autocomplete #auto="matAutocomplete">
              <mat-option *ngFor="let option of structuralDesignTypes" [value]="option.type">
                {{ option.type }}
              </mat-option>
            </mat-autocomplete>
          </div>
        </div>
        <div class="field-class-two-column">
          <div class="field-class-sub-left">
            <span class="field-label">{{'purpose' | translate}}</span>
            <input type="text" matInput formControlName="purpose" class="input-field" placeholder="Enter Purpose"/>
          </div>
          <div class="field-class-sub-right">
            <span class="field-label">{{'operationalStatus' | translate}}</span>
            <input id="operationalStatus" type="text" matInput  [matAutocomplete]="auto1" formControlName="operationalStatus" class="input-field" placeholder="Enter Operational Status"/>
            <mat-autocomplete #auto1="matAutocomplete">
              <mat-option *ngFor="let type of operationalStatus" [value]="type.type">
                  {{ type.type }}
              </mat-option>
            </mat-autocomplete>
          </div>    
        </div>            
      </div>

      <div class="btn-area">
        <button type="button" class="cancel-btn" (click)="onClose()">{{'cancel' | translate}}</button>
        <div>
          <button type="button" class="back-btn" matStepperPrevious>{{'back' | translate}}</button>    
          <button type="button" class="next-btn" matStepperNext>{{'next' | translate}}</button>
        </div>
      </div>
    </form>
  </mat-step>
  <mat-step [stepControl]="vesselStepper.sectionThreeFormGroup">
    <form [formGroup]="vesselStepper.sectionThreeFormGroup" autocomplete="off" class="overflow-y-auto max-h-[calc(100vh-16rem)]">
      <ng-template matStepLabel>Section 3</ng-template>
      <div class="main-area">
        <div class="sub-title">{{'me' | translate}}</div>   
        <div class="field-class">
          <span class="field-label">{{'mainEngineTypeCylinderLayout' | translate}}</span>
          
          <p-dropdown 
            [options]="engineTypes" 
            [(ngModel)]="selectedMEType" 
            formControlName="MEEngineType"
            optionLabel="type" 
            placeholder="Select the Vessel Type" 
            [style]="{'background-color': 'white', 'height': '3rem', 'border': '1px solid #828282', 'border-radius': '0.25rem', 'padding': '0 0.5rem', 'width': '100%'}">
          </p-dropdown>
        </div>
        <div class="field-class">
          <span class="field-label">{{'mainEngineTypeAdditionalInfo' | translate}}</span>
          <input type="text" matInput formControlName="METype" id="METype" class="input-field" placeholder="Enter any Additional Main Engine Type Information"/>
        </div>                      
        <div class="field-class-two-column">
          <div class="field-class-sub-left">
            <span class="field-label">{{'numOfDG' | translate}}</span>
            <input type="text" matInput class="input-field" placeholder="Enter No. of D/G" formControlName="NoDG">
          </div>
          <div class="field-class-sub-right">       
            <span class="field-label">{{'numOfShaftGenerators' | translate}}</span>
            <input type="text" matInput class="input-field" placeholder="Enter No. of S/G" formControlName="NoSG">
          </div>
        </div>
        <div class="field-class-two-column">
          <div class="field-class-sub-left">
            <span class="field-label">{{'cylinderBoreDiameter' | translate}}</span>
            <input type="text" matInput class="input-field" id="bore" placeholder="Select Bore" formControlName="bore">  
          </div>
          <div class="field-class-sub-right">       
            <span class="field-label">{{'cylinderStrokeLength' | translate}}</span>
            <input type="text" matInput class="input-field" placeholder="Enter Number of Stroke" id="stroke" formControlName="stroke">
          </div>
        </div>
        <div class="field-class-two-column">
          <div class="field-class-sub-left">
            <span class="field-label">{{'cylinder' | translate}}</span>
            <input type="text" matInput class="input-field" id="cylinder" placeholder="Enter Number of Cylinders" formControlName="cylinder">  
          </div>
          <div class="field-class-sub-right">       
            <span class="field-label">{{'engineStrokeCycle' | translate}}</span>
            <input type="text" matInput class="input-field" placeholder="Select Engine Stroke Cycle" id="cycle" formControlName="cycle">
          </div>
        </div>  
        <div class="field-class">
          <span class="field-label">{{'mainEngineMaxKW' | translate}}</span>
          <input type="number" matInput id="meMaxKw" placeholder="Enter Main Engine Max. KW" formControlName="meMaxKw" class="input-field"/>
        </div>
        <div class="field-class-two-column">
          <div class="field-class-sub-left">
            <span class="field-label">{{'mainEngineMaxRPM' | translate}}</span>
            <input type="text" matInput class="input-field" id="meMaxRpm" placeholder="Enter M/E Max. RPM" formControlName="meMaxRpm">  
          </div>
          <div class="field-class-sub-right">       
            <span class="field-label">{{'mainEngineMinRPM' | translate}}</span>
            <input type="text" matInput class="input-field" placeholder="Enter M/E Minimum RPM" id="meMinRpm" formControlName="meMinRpm">
          </div>
        </div>
        <div class="field-class-two-column">
          <div class="field-class-sub-left">
            <span class="field-label">{{'normalMainEngineMaxKW' | translate}}</span>
            <input type="text" matInput class="input-field" id="normalMeMaxKw" placeholder="Enter Normal Main Engine Max. Kw" formControlName="normalMeMaxKw">  
          </div>
          <div class="field-class-sub-right">       
            <span class="field-label">{{'normalMainEngineMaxRPM' | translate}}</span>
            <input type="text" matInput class="input-field" placeholder="Enter Normal Main Engine Max. RPM" id="normalMeMaxRpm" formControlName="normalMeMaxRpm">
          </div>
        </div>
        <div class="field-class-two-column">
          <div class="field-class-sub-left">
            <span class="field-label">{{'engineFuelOilUnit' | translate}}</span>
            <input type="text" matInput [matAutocomplete]="auto7" class="input-field" id="engineFoUnit" placeholder="Enter Engine FO Unit" formControlName="engineFoUnit">  
            <mat-autocomplete #auto7="matAutocomplete">
              <mat-option *ngFor="let type of engineFoUnitType" [value]="type.value">
                {{ type.type }}
              </mat-option>
            </mat-autocomplete>
          </div>
          <div class="field-class-sub-right">       
            <span class="field-label">{{'engineFuelOilUnitFactor' | translate}}</span>
            <input type="text" matInput class="input-field" placeholder="Enter Engine FO Unit Factor" id="engineFoUnitFactor" formControlName="engineFoUnitFactor">
          </div>
        </div>
        
        <div class="sub-title">{{'gen' | translate}}</div>   
        <div class="field-class-two-column">
          <div class="field-class-sub-left">
            <span class="field-label">{{'sgMaxKW' | translate}}</span>
            <input type="text" matInput id="sgMaxKw" placeholder="Enter S/G Max. KW" formControlName="sgMaxKw" class="input-field"/>
          </div>
          <div class="field-class-sub-right">       
            <span class="field-label">{{'dgMaxKW' | translate}}</span>
            <input type="text" matInput class="input-field" placeholder="Enter D/G Max. KW" id="geMaxKw" formControlName="geMaxKw">
          </div>
        </div>
        <div class="field-class-two-column">
          <div class="field-class-sub-left">
            <span class="field-label">{{'geFuelOilUnit' | translate}}</span>
            <input type="text" matInput [matAutocomplete]="auto7" class="input-field" id="generatorFoUnit" placeholder="Enter Generator FO Unit" formControlName="generatorFoUnit">  
            <mat-autocomplete #auto7="matAutocomplete">
              <mat-option *ngFor="let type of engineFoUnitType" [value]="type.value">
                {{ type.type }}
              </mat-option>
            </mat-autocomplete>
          </div>
          <div class="field-class-sub-right">       
            <span class="field-label">{{'geFuelOilUnitFactor' | translate}}</span>
            <input type="text" matInput class="input-field" placeholder="Enter Generator FO Unit Factor" id="generatorFoUnitFactor" formControlName="generatorFoUnitFactor">
          </div>
        </div>

        <div class="sub-title">{{'fuel_con_info' | translate}}</div>   
        <div class="field-class-two-column">
          <div class="field-class-sub-left">
            <span class="field-label">{{'meFuelConsumptionRate' | translate}}</span>
            <input type="text" matInput id="meFuelConsumptionRate" placeholder="Enter ME Fuel Consumption Rate" formControlName="meFuelConsumptionRate" class="input-field"/>
          </div>
          <div class="field-class-sub-right">       
            <span class="field-label">{{'geFuelConsumptionRate' | translate}}</span>
            <input type="text" matInput class="input-field" placeholder="Enter GE Fuel Consumption Rate" id="geFuelConsumptionRate" formControlName="geFuelConsumptionRate">
          </div>
        </div> 

        <div class="sub-title">{{'rudder&propInfo' | translate}}</div>   
        <div class="field-class-two-column">
          <div class="field-class-sub-left">
            <span class="field-label">{{'noRudders' | translate}}</span>
            <input type="text" matInput id="NoRudders" placeholder="Enter No Rudders" formControlName="NoRudders" class="input-field"/>
          </div>
          <div class="field-class-sub-right">       
            <span class="field-label">{{'rudderType' | translate}}</span>
            <input type="text" [matAutocomplete]="auto2" matInput class="input-field" placeholder="Enter Rudder Type" id="rudderType" formControlName="rudderType">
            <mat-autocomplete #auto2="matAutocomplete">
              <mat-option *ngFor="let type of RudderTypes" [value]="type.type">
                  {{ type.type }}
              </mat-option>
            </mat-autocomplete>
          </div>
        </div> 
        <div class="field-class">
          <span class="field-label">{{'propellerType' | translate}}</span>
          <input type="text" formControlName="propellerType" matInput [matAutocomplete]="auto3" id="propellerType" class="input-field" placeholder="Enter Propeller Type"/>
          <mat-autocomplete #auto3="matAutocomplete">
            <mat-option *ngFor="let type of PropellerTypes" [value]="type.type">
                {{ type.type }}
            </mat-option>
          </mat-autocomplete>
        </div>
        <div class="field-class-two-column">
          <div class="field-class-sub-left">
            <span class="field-label">{{'bladeDiameter' | translate}}</span>
            <input type="text" matInput id="bladeDiameter" placeholder="Enter Blade Diameter" formControlName="bladeDiameter" class="input-field"/>
          </div>
          <div class="field-class-sub-right">       
            <span class="field-label">{{'numOfBlades' | translate}}</span>
            <input type="text" matInput class="input-field" placeholder="Enter No. of Blades" id="NoBlades" formControlName="NoBlades">
          </div>
        </div>
        <div class="field-class-two-column">
          <div class="field-class-sub-left">
            <span class="field-label">{{'minCPPAngle' | translate}}</span>
            <input type="text" matInput id="minCPPAngle" placeholder="Enter Min CPP Angle" formControlName="minCPPAngle" class="input-field"/>
          </div>
          <div class="field-class-sub-right">       
            <span class="field-label">{{'maxCPPAngle' | translate}}</span>
            <input type="text" matInput class="input-field" placeholder="Enter Max CPP Angle" id="maxCPPAngle" formControlName="maxCPPAngle">
          </div>
        </div>
      </div>

      <div class="btn-area">
        <button type="button" class="cancel-btn" (click)="onClose()">{{'cancel' | translate}}</button>
        <div>
          <button type="button" class="back-btn" matStepperPrevious>{{'back' | translate}}</button>    
          <button type="button" class="next-btn" matStepperNext>{{'next' | translate}}</button>
        </div>
      </div>
    </form>
  </mat-step>
  <mat-step [stepControl]="vesselStepper.sectionFourFormGroup">
    <form [formGroup]="vesselStepper.sectionFourFormGroup" autocomplete="off" class="overflow-y-auto max-h-[calc(100vh-16rem)]">
      <ng-template matStepLabel>Section 4</ng-template>
      <div class="main-area">
        <div class="sub-title">{{'ccapacity' | translate}}</div>   
        <div class="field-class-two-column">
          <div class="field-class-sub-left">
            <span class="field-label">{{'noTank' | translate}}</span>
            <input type="text" matInput id="NoTank" placeholder="Enter No Tank" formControlName="NoTank" class="input-field"/>
          </div>
          <div class="field-class-sub-right">       
            <span class="field-label">{{'passengerCapacity' | translate}}</span>
            <input type="text" matInput class="input-field" placeholder="Enter Passenger Capacity" id="passengerCapacity" formControlName="passengerCapacity">
          </div>
        </div> 
        <div class="field-class-two-column">
          <div class="field-class-sub-left">
            <span class="field-label">{{'bale' | translate}}</span>
            <input type="text" matInput id="cargoBaleM3" placeholder="Enter Bale" formControlName="cargoBaleM3" class="input-field"/>
          </div>
          <div class="field-class-sub-right">       
            <span class="field-label">{{'grain' | translate}}</span>
            <input type="text" matInput class="input-field" placeholder="Enter Grain" id="cargoGrainM3" formControlName="cargoGrainM3">
          </div>
        </div> 
        <div class="field-class-two-column">
          <div class="field-class-sub-left">
            <span class="field-label">{{'liquid' | translate}}</span>
            <input type="text" matInput id="cargoLiquidM3" placeholder="Enter Liquid" formControlName="cargoLiquidM3" class="input-field"/>
          </div>
          <div class="field-class-sub-right">       
            <span class="field-label">{{'refrigerated' | translate}}</span>
            <input type="text" matInput class="input-field" placeholder="Enter Refrigerated" id="cargoRefM3" formControlName="cargoRefM3">
          </div>
        </div> 
        <div class="field-class-two-column">
          <div class="field-class-sub-left">
            <span class="field-label">{{'numOf20FeetContainer' | translate}}</span>
            <input type="text" matInput id="cargoNoTeu" placeholder="Enter No. of 20 Feet Container" formControlName="cargoNoTeu" class="input-field"/>
          </div>
          <div class="field-class-sub-right">       
            <span class="field-label">{{'numOf40FeetContainer' | translate}}</span>
            <input type="text" matInput class="input-field" placeholder="Enter No. of 40 Feet Container" id="cargoNoFeu" formControlName="cargoNoFeu">
          </div>
        </div> 
        <div class="field-class-two-column">
          <div class="field-class-sub-left">
            <span class="field-label">{{'numOfCars' | translate}}</span>
            <input type="text" matInput id="cargoNoCar" placeholder="Enter No.of Cars" formControlName="cargoNoCar" class="input-field"/>
          </div>
          <div class="field-class-sub-right">       
            <span class="field-label">{{'numOfTrucks' | translate}}</span>
            <input type="text" matInput class="input-field" placeholder="Enter No.of Trucks" id="cargoNoTruck" formControlName="cargoNoTruck">
          </div>
        </div> 
        <div class="field-class-two-column">
          <div class="field-class-sub-left">
            <span class="field-label">{{'numOfTrailers' | translate}}</span>
            <input type="text" matInput id="cargoNoTrailer" placeholder="Enter No.of Trailers" formControlName="cargoNoTrailer" class="input-field"/>
          </div>
          <div class="field-class-sub-right">       
            <span class="field-label">{{'numOfForklifts' | translate}}</span>
            <input type="text" matInput class="input-field" placeholder="Enter No.of Forklifts" id="cargoNoForklift" formControlName="cargoNoForklift">
          </div>
        </div> 
        <div class="field-class-two-column">
          <div class="field-class-sub-left">
            <span class="field-label">{{'numOfBulldozers' | translate}}</span>
            <input type="text" matInput id="cargoNoBulldozer" placeholder="Enter No.of Bulldozers" formControlName="cargoNoBulldozer" class="input-field"/>
          </div>
          <div class="field-class-sub-right">       
            <span class="field-label">{{'numOfChassis' | translate}}</span>
            <input type="text" matInput class="input-field" placeholder="Enter No.of Chassis" id="cargoNoChassis" formControlName="cargoNoChassis">
          </div>
        </div> 
        <div class="field-class">
          <span class="field-label">{{'numOfTrainCars' | translate}}</span>
          <input type="text" matInput id="cargoNoTrainCar" placeholder="Enter No.of Train Cars" formControlName="cargoNoTrainCar" class="input-field"/>
        </div>
        <div class="field-class-two-column">
          <div class="field-class-sub-left">
            <span class="field-label">{{'customizedUnitForCargo' | translate}}</span>
            <input type="text" matInput id="cargoOtherUnit" placeholder="Enter Customized Unit" formControlName="cargoOtherUnit" class="input-field"/>
          </div>
          <div class="field-class-sub-right">       
            <span class="field-label">{{'capacity' | translate}}</span>
            <input type="text" matInput class="input-field" placeholder="Enter Cargo Capacity" id="cargoOtherCapacity" formControlName="cargoOtherCapacity">
          </div>
        </div> 

        <div class="sub-title">{{'tcapactiy' | translate}}</div>   
        <div class="field-class-two-column">
          <div class="field-class-sub-left">
            <span class="field-label">{{'fuelOilDieselOil' | translate}}</span>
            <input type="text" matInput id="tankCapacityFoM3" placeholder="Enter Fuel Oil & Diesel Oil" formControlName="tankCapacityFoM3" class="input-field"/>
          </div>
          <div class="field-class-sub-right">       
            <span class="field-label">{{'freshWater' | translate}}</span>
            <input type="text" matInput class="input-field" placeholder="Enter Fresh Water" id="tankCapacityFwM3" formControlName="tankCapacityFwM3">
          </div>
        </div>
        <div class="field-class">       
          <span class="field-label">{{'waterBallast' | translate}}</span>
          <input type="text" matInput class="input-field" placeholder="Enter Water Ballast" id="tankCapacityWbM3" formControlName="tankCapacityWbM3">
        </div>
      </div>  

      <div class="btn-area">
        <button type="button" class="cancel-btn" (click)="onClose()">{{'cancel' | translate}}</button>
        <div>
          <button type="button" class="back-btn" matStepperPrevious>{{'back' | translate}}</button>    
          <button type="button" class="next-btn" matStepperNext>{{'next' | translate}}</button>
        </div>
      </div>
    </form>
  </mat-step>
  <mat-step [stepControl]="vesselStepper.sectionFiveFormGroup">
    <form [formGroup]="vesselStepper.sectionFiveFormGroup" autocomplete="off" class="overflow-y-auto max-h-[calc(100vh-16rem)]">
      <ng-template matStepLabel>Section 5</ng-template>
      <div class="main-area">
        <div class="sub-title">{{'dates' | translate}}</div> 
        <div class="field-class-two-column">
          <div class="field-class-sub-left">       
            <span class="field-label">{{'steelCuttingDate' | translate}}</span>
            <p-inputMask mask="9999-99-99" slotChar="yyyy-mm-dd" class="input-field" placeholder="Enter Steel Cutting Date" id="steelCuttingDate" formControlName="steelCuttingDate"></p-inputMask>
          </div>
          <div class="field-class-sub-right">       
            <span class="field-label">{{'keelLayingDate' | translate}}</span>
            <p-inputMask mask="9999-99-99" slotChar="yyyy-mm-dd" class="input-field" placeholder="Enter Keel Laying Date" id="keelLayingDate" formControlName="keelLayingDate"></p-inputMask>
          </div>
        </div>
        <div class="field-class-two-column">
          <div class="field-class-sub-left">       
            <span class="field-label">{{'launchDate' | translate}}</span>
            <p-inputMask mask="9999-99-99" slotChar="yyyy-mm-dd" class="input-field" placeholder="Enter Launch Date" id="launchDate" formControlName="launchDate"></p-inputMask>
          </div>
          <div class="field-class-sub-right">       
            <span class="field-label">{{'deliveryDate' | translate}}</span>
            <p-inputMask mask="9999-99-99" slotChar="yyyy-mm-dd" class="input-field" placeholder="Enter Delivery Date" id="deliveryDate" formControlName="deliveryDate"></p-inputMask>
          </div>
        </div>  

        <div class="sub-title">{{'c&notation' | translate}}</div> 
        <div class="field-class-two-column">
          <div class="field-class-sub-left">       
            <span class="field-label">{{'noCrewMembers' | translate}}</span>
            <input type="text" matInput class="input-field" placeholder="Enter No Crew Members" id="NoCrewMembers" formControlName="NoCrewMembers">
          </div>
          <div class="field-class-sub-right">       
            <span class="field-label">{{'notation' | translate}}</span>
            <input type="text" matInput class="input-field" placeholder="Enter Notation" id="notation" formControlName="notation">
          </div>
        </div>  
      </div>
      <div class="btn-area">
        <button type="button" class="cancel-btn" (click)="onClose()">{{'cancel' | translate}}</button>
        <div>
          <button type="button" class="back-btn" matStepperPrevious>{{'back' | translate}}</button>    
          <button type="button" class="next-btn" matStepperNext>{{'next' | translate}}</button>
        </div>
      </div>
    </form>
  </mat-step>
  <mat-step [stepControl]="vesselStepper.sectionSixFormGroup">
    <form [formGroup]="vesselStepper.sectionSixFormGroup" autocomplete="off" class="overflow-y-auto max-h-[calc(100vh-16rem)]">
      <ng-template matStepLabel>Section 6</ng-template>
      <div class="main-area">
        <div class="sub-title">{{'sInfo' | translate}}</div> 
        <div class="field-class-two-column">
          <div class="field-class-sub-left">       
            <span class="field-label">{{'salesRepName' | translate}}</span>
            <input type="text" matInput class="input-field" placeholder="Enter Sales Representative Name" id="salesRepresentativeName" formControlName="salesRepresentativeName">
          </div>
          <div class="field-class-sub-right">       
            <span class="field-label">{{'salesAddress' | translate}}</span>
            <input type="text" matInput class="input-field" placeholder="Enter Sales Address" id="salesAddress" formControlName="salesAddress">
          </div>
        </div>
        <div class="field-class-two-column">
          <div class="field-class-sub-left">       
            <span class="field-label">{{'salesEmail' | translate}}</span>
            <input type="text" matInput class="input-field" placeholder="Enter Sales Email" id="salesEmail" formControlName="salesEmail">
          </div>
          <div class="field-class-sub-right">       
            <span class="field-label">{{'salesTelephone' | translate}}</span>
            <input type="text" matInput class="input-field" placeholder="Enter Sales Telephone" id="salesTelephone" formControlName="salesTelephone">
          </div>
        </div>  
          
        <div class="sub-title">{{'sainfo' | translate}}</div>   
        <div class="field-class-two-column">
          <div class="field-class-sub-left">
            <span class="field-label">{{'salesAgentName' | translate}}</span>
            <input type="text" matInput id="salesAgentName" placeholder="Enter Sales Agent Name" formControlName="salesAgentName" class="input-field"/>
          </div>
          <div class="field-class-sub-right">       
            <span class="field-label">{{'salesAgentAddress' | translate}}</span>
            <input type="text" matInput class="input-field" placeholder="Enter Sales Agent Address" id="salesAgentAddress" formControlName="salesAgentAddress">
          </div>
        </div>
        <div class="field-class-two-column">
          <div class="field-class-sub-left">       
            <span class="field-label">{{'salesAgentEmail' | translate}}</span>
            <input type="text" matInput class="input-field" placeholder="Enter Sales Agent Email" id="salesAgentEmail" formControlName="salesAgentEmail">
          </div>
          <div class="field-class-sub-right">       
            <span class="field-label">{{'salesAgentTelephone' | translate}}</span>
            <input type="text" matInput class="input-field" placeholder="Enter Sales Agent Telephone" id="salesAgentTelephone" formControlName="salesAgentTelephone">
          </div>
        </div>
        <div class="sub-title">{{'vwarrantyInfo' | translate}}</div>   
        <div class="field-class-two-column">
          <div class="field-class-sub-left">
            <span class="field-label">*{{'vesselWarrantyStartDate' | translate}}</span>
            <p-inputMask mask="9999-99-99" slotChar="yyyy-mm-dd" formControlName="vesselWarrantyStartDate" placeholder="Enter Vessel Warranty Start Date" [required]="true" [autoFocus] = "false" class="input-field"></p-inputMask> 
            <div *ngIf="sectionSixForm.get('vesselWarrantyStartDate')?.hasError('required') && sectionSixForm.get('vesselWarrantyStartDate')?.touched" class="error-message">
              This Field is Required
            </div>
          </div>
          <div class="field-class-sub-right">
            <span class="field-label">*{{'vesselWarrantyBaseExpDate' | translate}}</span>
            <p-inputMask mask="9999-99-99" slotChar="yyyy-mm-dd" formControlName="vesselWarrantyBaseExpDate" placeholder="Enter Vessel Warranty Base Exp. Date" [required]="true" [autoFocus] = "false" class="input-field"></p-inputMask>
            <div *ngIf="sectionSixForm.get('vesselWarrantyBaseExpDate')?.hasError('required') && sectionSixForm.get('vesselWarrantyBaseExpDate')?.touched" class="error-message">
              This Field is Required
            </div>
          </div>
        </div>
        <div class="field-class-two-column">
          <div class="field-class-sub-left">       
            <span class="field-label">*{{'vesselWarrantyExtExpDate' | translate}}</span>
            <p-inputMask mask="9999-99-99" slotChar="yyyy-mm-dd" formControlName="vesselWarrantyExtExpDate" placeholder="Enter Vessel Warranty Ext.Exp.Date" [required]="true" [autoFocus] = "false" class="input-field"></p-inputMask>
            <div *ngIf="sectionSixForm.get('vesselWarrantyExtExpDate')?.hasError('required') && sectionSixForm.get('vesselWarrantyExtExpDate')?.touched" class="error-message">
              This Field is Required
            </div>                
          </div>
          <div class="field-class-sub-right">       
            <span class="field-label">*{{'vesselWarrantyExpDate' | translate}}</span>
            <p-inputMask mask="9999-99-99" slotChar="yyyy-mm-dd" formControlName="vesselWarrantyExpDate" placeholder="Enter Vessel Warranty Exp.Date" [required]="true" [autoFocus] = "false" class="input-field"></p-inputMask>
            <div *ngIf="sectionSixForm.get('vesselWarrantyExpDate')?.hasError('required') && sectionSixForm.get('vesselWarrantyExpDate')?.touched" class="error-message">
              This Field is Required
            </div>
          </div>
        </div>
        <div class="sub-title">{{'iEdgeDevice' | translate}}</div>   
        <div class="field-class">
          <p style="margin-top: 10px;">
            <span class="field-label" style="margin-top: 10px; margin-right: 8px;">{{'createiEdgeDevice' | translate}}</span> 
            <mat-button-toggle-group formControlName="isEdge">
              <mat-button-toggle [value]="1" >
                {{ 'yes' | translate }}
              </mat-button-toggle>
              <mat-button-toggle [value]="0">
                {{ 'no' | translate }}
              </mat-button-toggle>
            </mat-button-toggle-group>
          </p>
        </div>

        <form [formGroup]="vesselStepper.businesSection" autocomplete="off">
          <div class="sub-title">{{'bizactivity' | translate}}</div>   
          <div class="field-class-two-column">
            <div class="field-class-sub-left">
              <span class="field-label">{{'remark' | translate}}</span>
              <input type="text" matInput class="input-field" placeholder="Enter Remarks" id="remarks" formControlName="remarks">
            </div>
            <div class="field-class-sub-right">       
              <span class="field-label">{{'update' | translate}}</span>
              <p-inputMask mask="9999-99-99" slotChar="yyyy-mm-dd" formControlName="update" placeholder="Enter Update" [autoFocus] = "false" class="input-field"></p-inputMask>
            </div>
          </div>
          <div class="field-class-two-column">
            <div class="field-class-sub-left">       
              <span class="field-label">{{'budgetPeriod' | translate}}</span>
              <p-inputMask mask="9999-99-99" slotChar="yyyy-mm-dd" formControlName="budgetperiod" placeholder="Enter Budget Period" [autoFocus] = "false" class="input-field"></p-inputMask>
            </div>
            <div class="field-class-sub-right">       
              <span class="field-label">{{'activity' | translate}}</span>
              <input type="text" matInput class="input-field" placeholder="Enter Activities" id="activities" formControlName="activities">
            </div>
          </div>
          <div class="field-class-two-column">
            <div class="field-class-sub-left">       
              <span class="field-label">{{'smonth' | translate}}</span>
              <p-inputMask mask="9999-99-99" slotChar="yyyy-mm-dd" formControlName="salesmonth" placeholder="Enter Sales Month" [autoFocus] = "false" class="input-field" ></p-inputMask>
            </div>
            <div class="field-class-sub-right">       
              <span class="field-label">{{'proposalDetails' | translate}}</span>
              <input type="text" matInput class="input-field" placeholder="Enter Proposal Details" id="proposaldetails" formControlName="proposaldetails">
            </div>
          </div>

          <div class="field-class">       
            <p style="margin-top: 10px;">
              <span class="field-label">{{'cInput' | translate}}</span>
              <mat-button-toggle-group formControlName="completedinput">
                <mat-button-toggle value="true">
                  True
                </mat-button-toggle>
                <mat-button-toggle value="false">
                  False 
                </mat-button-toggle>
              </mat-button-toggle-group>
            </p>
          </div>
          <div class="field-class">
            <p style="margin-top: 10px;">
              <span class="field-label" style="margin-top: 10px;">{{'istConstruct' | translate}}</span> 
              <mat-button-toggle-group formControlName="lcstconfirm">
                <mat-button-toggle value="true" >
                  True
                </mat-button-toggle>
                <mat-button-toggle value="false">
                  False 
                </mat-button-toggle>
              </mat-button-toggle-group>
            </p>
          </div>
          <div class="field-class-two-column">
            <div class="field-class-sub-left">
              <span class="field-label">{{'nextRenewalSurveyDate' | translate}}</span>
              <p-inputMask mask="9999-99-99" slotChar="yyyy-mm-dd" formControlName="nextrenewalsurveydate" placeholder="Enter Next Renewal Survey Date" [autoFocus] = "false" class="input-field"></p-inputMask>
            </div>
            <div class="field-class-sub-right">
              <span class="field-label">{{'nextRenewalSurveyDetails' | translate}}</span>
              <input type="text" matInput  placeholder="Enter Next Renewal Survey Details" id="nextrenewalsurveydetails" formControlName="nextrenewalsurveydetails" class="input-field">
            </div>
          </div>
          <div class="field-class-two-column">
            <div class="field-class-sub-left">       
              <span class="field-label">{{'nextDockDates' | translate}}</span>
              <p-inputMask mask="9999-99-99" slotChar="yyyy-mm-dd" formControlName="nextdockdate" placeholder="Enter Next Dock Date" [autoFocus] = "false" class="input-field"></p-inputMask>
            </div>
            <div class="field-class-sub-right">       
              <span class="field-label">{{'nextDockDetails' | translate}}</span>
              <input type="text" matInput placeholder="Enter Next Dock Details" id="nextdockdetails" formControlName="nextdockdetails" class="input-field">
            </div>
          </div>
        </form>
      </div>
      <div class="btn-area">
        <button type="button" class="cancel-btn" (click)="onClose()">{{'cancel' | translate}}</button>
        <div>
          <button type="button" class="back-btn" matStepperPrevious>{{'back' | translate}}</button>
          <button *ngIf="!isSubmitting && !moveNext" type="button" class="submit-btn" (click)="onNext()" [disabled]="isSubmitting || !vesselStepper.sectionSixFormGroup.valid">
            <span >{{'addThisVessel' | translate}}</span>
          </button>
          <button mat-button class="next-btn" *ngIf="moveNext" matStepperNext>{{'next' | translate}}</button>
        </div>
      </div>

    </form>
  </mat-step>
  <mat-step [stepControl]="vesselStepper.sectionSevenFormGroup">
    <ng-template matStepLabel>Section 7</ng-template>
    <div class="sm:max-w-2xl mb-5">
      <div class="content mt-8 ml-14 grid grid-cols-3 gap-x-8 gap-y-5">
          <div class="col-span-1 text-tColor font-bold leading-normal font-sans">{{'uploadVesselPhoto' | translate}}</div>   
            <div class="col-span-2 flex flex-col gap-5">
              <div class="field-class">       
                <div class="uploding-section">
                  <label class="custom-file-upload">
                    <input type="file" (change)="onSelect($event)" accept="image/png" multiple>
                  <i class="pi pi-image"></i> Select Image
                  </label>
                  <button class="upload-button" (click)="uploadnewImage()" ><i class="pi pi-upload"></i> Upload</button>
                </div>
                
                <div style="display: flex; flex-direction: row; margin: 10px;">
                  <ng-container *ngIf="selectedImage">
                    <img [src]="selectedImage" alt="Selected Image" width="80px" height="80px">
                    <p style="margin: 5px;">{{ image?.name }}</p>
                  </ng-container>
                </div>
                <section [ngSwitch]="statusImg">
                  <p *ngSwitchCase="'uploading'">Uploading...</p>
                  <p *ngSwitchCase="'success'">Done!</p>
                  <p *ngSwitchCase="'fail'">Error!</p>
                </section>
              </div>
            </div>
          </div>
    </div>
    <div class="sm:max-w-2xl mb-5">
      <div class="content mt-8 ml-14 grid grid-cols-3 gap-x-8 gap-y-5">
          <div class="col-span-1 text-tColor font-bold leading-normal font-sans">{{'subscription' | translate}}</div>   
            <div class="col-span-2 flex flex-col gap-5">
              <div class="flex flex-col">
                <div style="width: 100px">
                  <p-treeSelect
                    [options]="primeNgDataset"
                    [(ngModel)]="selectedNodes"
                    [ngModelOptions]="{standalone: true}"
                    class="md:w-20px w-full"
                    containerStyleClass="w-full"
                    [panelStyle]="{ 'width': '50pxs' }"
                    placeholder="Select the item"
                    selectionMode="checkbox"
                    [metaKeySelection]="false"
                    [propagateSelectionUp]="false" 
                    [propagateSelectionDown]="false"
                    [showClear]="false"
                    [filter]="false"
                    (onNodeSelect)="onNodeSelect($event)"
                    (onNodeUnselect)="onNodeUnselect($event)"  
                    display="chip"> 
                    <ng-template pTemplate="header" let-node>
                    </ng-template> 
                  </p-treeSelect>
                </div>
                <br><br><br>
                <div style="width: 26.25rem">
                  <p-tree class="w-full md:w-26.25rem" 
                    [value]="primeNgTreeDataSet" 
                    [metaKeySelection]="false"
                    [propagateSelectionUp]="false" 
                    [propagateSelectionDown]="false"
                    expanded = "true"
                  ></p-tree>
                </div>
              </div> 
              <div class="flex flex-col">
                <button class="upload-button" (click)="upload_applications()" style="width: 150px;"><i class="pi pi-plus"></i> Subscribe</button>
                <section [ngSwitch]="statusApp">
                  <p *ngSwitchCase="'uploading'">Uploading...</p>
                  <p *ngSwitchCase="'success'">Done!</p>
                  <p *ngSwitchCase="'fail'">Error!</p>
                </section>
              </div>   
          </div>
      </div>
    </div>
    <div class="sm:max-w-2xl mb-5">
      <div class="content mt-8 ml-14 grid grid-cols-3 gap-x-8 gap-y-5">
          <div class="col-span-1 text-tColor font-bold leading-normal font-sans">{{'vessselMappingFileUpload' | translate}}</div>   
            <div class="col-span-2 flex flex-col gap-5">
              <div class="flex flex-col">
                <label class="custom-file-upload" style="width: 150px;">
                  <input type="file" class="file-inputs" (change)="onChange($event)" />
                <i class="pi pi-file"></i> Select a File
                </label>
                  <div *ngIf="file">
                    <section class="file-info">
                      File details:
                      <ul>
                        <li>Name: {{file.name}}</li>
                        <li>Type: {{file.type}}</li>
                        <li>Size: {{file.size}} bytes</li>
                      </ul>
                    </section>
                  
                    <button (click)="getSelectedVesselId()" class="upload-button" type="button"><i class="pi pi-upload"></i> Upload</button>
                  
                  <section [ngSwitch]="status">
                      <p *ngSwitchCase="'uploading'">Uploading...</p>
                      <p *ngSwitchCase="'success'">Done!</p>
                      <p *ngSwitchCase="'fail'">Error!</p>
                      <p *ngSwitchDefault>Waiting to upload...</p>
                    </section><br /><br /><br /><br /><br />
                    </div>
              </div> 
          </div>
      </div>
    </div>
    <div class="btn-area">
      <button type="button" class="cancel-btn" (click)="onClose()">{{'cancel' | translate}}</button>
      <button mat-button class="next-btn" *ngIf="moveNext" matStepperNext>{{'next' | translate}}</button>
    </div>
  </mat-step>
  <mat-step [stepControl]="vesselStepper.sectionEightFormGroup">
    <form [formGroup]="vesselStepper.sectionEightFormGroup" autocomplete="off">
      <ng-template matStepLabel>Section 8</ng-template>
      <div class="main-area">
        <div class="sub-title">{{'offlineStatusMessage' | translate}}</div>   
        <div class="field-class-two-column">
          <div class="field-class-sub-left">       
            <span class="field-label">{{'offlineTitle' | translate}}</span>
            <input type="text" matInput placeholder="Enter title" id="offlineTitle" formControlName="offlineTitle" class="input-field">
          </div>
          <div class="field-class-sub-right">       
            <span class="field-label">{{'offlineContent' | translate}}</span>
            <input type="text" matInput placeholder="Enter content" id="offlineContent" formControlName="offlineContent" class="input-field">
          </div>
        </div>
        <div class="field-class">       
          <span class="field-label">{{'offlinehtmlContnet' | translate}}</span>
          <input type="text" matInput placeholder="Enter HTML Content" id="offlinehtmlContnet" formControlName="offlinehtmlContnet" class="input-field">
        </div>

        <div class="sub-title">{{'onlineStatusMessage' | translate}}</div>   
        <div class="field-class-two-column">
          <div class="field-class">       
            <span class="field-label">{{'onlineTitle' | translate}}</span>
            <input type="text" matInput placeholder="Enter title" id="onlineContent" formControlName="onlineContent" class="input-field">
          </div>
          <div class="field-class">       
            <span class="field-label">{{'onlineContent' | translate}}</span>
            <input type="text" matInput placeholder="Enter content" id="onlineContent" formControlName="onlineContent" class="input-field">
          </div>
        </div>
        <div class="field-class">       
          <span class="field-label">{{'onlinehtmlContnet' | translate}}</span>
          <input type="text" matInput placeholder="Enter HTML Content" id="onlinehtmlContnet" formControlName="onlinehtmlContnet" class="input-field">
        </div>
      </div>
      <div class="btn-area">
        <button type="button" class="cancel-btn" (click)="onClose()">{{'cancel' | translate}}</button>
        <div>
          <button type="button" class="back-btn" matStepperPrevious>{{'back' | translate}}</button>    
          <button type="button" class="next-btn" matStepperNext (click)="createAlert()">{{'next' | translate}}</button>
        </div>
      </div>
    </form>
  </mat-step>
  <mat-step>
    <ng-template matStepLabel>Done</ng-template>
    <div class="main-area">{{'yourDone' | translate}}</div>
    <div class="btn-area">
      <div></div>
      <button type="button" class="next-btn" (click)="onClose()">{{'finish' | translate}}</button>
    </div>
  </mat-step>
</mat-stepper>